module.exports = __webpack_public_path__ + "static/img/shake.29361c44.webp";